import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DocumentSignedByTypeEnum } from 'src/app/domain/enums/documents/document-signed-by-type.enum';

@Pipe({
    name: 'signatureType',
    standalone: true,
    pure: false,
})
export class SignatureTypePipe implements PipeTransform {
    private _translate = inject(TranslateService);

    transform(type: DocumentSignedByTypeEnum | null | undefined): string {
        if (!type) return '';

        const key = `shared.signatureType.${type}`;
        const translated = this._translate.instant(key);

        return translated !== key ? translated : this._translate.instant('shared.signatureType.default');
    }
}
